import { Box, Button, Flex, Image, Text } from "@mantine/core";
import { SECTION } from "pages/term-deposit/images";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "utils/common";
import { v4 as uuidv4 } from "uuid";

type SettlementItem = {
  label: string;
  value: string;
};

type TransactionResponseProps = {
  image: string;
  message: string;
  amount: number;
  info: SettlementItem[];
};

const TransactionResponse = ({
  image,
  message,
  amount,
  info,
}: TransactionResponseProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        gap: "20px",
        padding: "10px 13px",
        flexDirection: "column",
        borderRadius: "8px",
      }}
    >
      {/* Transaction Amount Section */}
      <Flex direction="column" mx="auto" gap={20} w={640}>
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            padding: "10px 13px",
            flexDirection: "column",
            backgroundColor: "#FDFDFD",
            borderRadius: "8px",
          }}
        >
          <Flex align="center" direction="column" gap={3}>
            <Box w={125}>
              <Image src={image} alt="image" />
            </Box>
            <Text size="md" fw={600}>
              {message}
            </Text>
          </Flex>
          <Box
            sx={{
              backgroundColor: "#FDFDFD",
              borderRadius: "8px",
              height: "90px",
              backgroundImage: `url(${SECTION})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                textAlign: "center",
                color: "#FDFDFD",
                padding: "8px 0",
                margin: "auto 0",
              }}
            >
              <Text
                sx={{
                  fontWeight: 600,
                  fontSize: "30px",
                }}
              >
                {formatCurrency(amount)} VND
              </Text>
            </Box>
          </Box>
          {/* Info list */}
          <Flex px={20} gap="md" direction="column" fw="sm" color="#0E121B">
            {info.map((item) => (
              <Flex key={uuidv4()} justify="space-between">
                <Text>{item.label}</Text>
                <Text fw={600}>{item.value}</Text>
              </Flex>
            ))}
          </Flex>
        </Box>
        <Flex justify="space-between" gap="sm">
          <Button
            variant="outline"
            sx={{
              color: "#2A81D0",
              borderColor: "#2A81D0",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#F0F5FF",
              },
            }}
            fullWidth
            onClick={() => {
              navigate("/");
            }}
          >
            {t("HOME")}
          </Button>

          <Button
            variant="filled"
            sx={{
              backgroundColor: "#2A81D0",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#1E679E",
              },
            }}
            fullWidth
          >
            {t("ADD_NEW_TRANSACTION")}
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default TransactionResponse;
